import React, { useState } from 'react';
import {
    Container,
    Typography,
    useTheme,
    useMediaQuery,
    Stack,
    Box
} from '@mui/material';
import '@fontsource/poppins';
import Footsteps from '../../assets/icons/Footsteps';
import OurApproachCard from './OurApproachCard';
import image1 from '../../assets/Images/image1.webp';
import image2 from '../../assets/Images/image2.webp';
import PereToPereIcon from '../../assets/icons/PeerToPeerIcon';
import PereCircleIcon from '../../assets/icons/PereCircleIcon';
import TalentIcon from '../../assets/icons/TalentIcon';
import TalentCircleIcon from '../../assets/icons/TalentCircleIcon';
import AlgoCircleIcon from '../../assets/icons/AlgoCircleIcon';
import AlgoIcon from '../../assets/icons/AlgoIcon';
import JobfactorScoreCircleIcon from '../../assets/icons/JobfactorScoreCircleIcon';
import JobfactorScoreIcon from '../../assets/icons/JobfactorScoreIcon';
import SkillBasedCircleIcon from '../../assets/icons/SkillBasedCircleIcon';
import SkillsBasedIcon from '../../assets/icons/SkillsBasedIcon';
import SocialMediaIcon from '../../assets/icons/SocialMediaIcon';
import SocialMediaCircleIcon from '../../assets/icons/SocialMediaCircleIcon';
import UpfrontCircleIcon from '../../assets/icons/UpfrontCircleIcon';
import UpfrontIcon from '../../assets/icons/UpfrontIcon';

const OurApproach = () => {
    const OurApproachCards = [
        {
            // Peer-to-peer Reviews
            id: 1,
            icon2: <PereCircleIcon />,
            icon: <PereToPereIcon />,
            icon3: <PereToPereIcon width="64px" height="64px" fill="#E67E22" />,

            background2:
                'linear-gradient(90deg, rgba(255, 81, 47, 0.30) 0%, rgba(240, 152, 25, 0.30) 100%)',
            text: 'Peer-to-Peer Review',
            iconBackground: '#E67E22',
            description1:
                "Your   success  is  amplified  through  the   collective   power   of   peer-to-peer reviews. Contribute to your colleagues' growth, share valuable insights, and earn opportunities that align with your expertise. Jobfactor's collaborative environment propels your career to new heights.",
            description2:
                ' Gain   unprecedented   insights   into   the   skills   and   capabilities   of   potential candidates through peer reviews. Jobfactor fosters an environment of transparency, allowing you to make informed decisions and build a team that excels together. Not only that, your employees become your voice to the world as they share their experience and amplify your amazing culturefar and wide'
        },
        {
            //  Talent Transformation: Forging Lasting Connections at Jobfactor
            id: 2,
            icon2: <TalentCircleIcon />,
            icon: <TalentIcon />,
            icon3: <TalentIcon width="64px" height="64px" fill="#2ECC71" />,
            background2:
                'linear-gradient(90deg, rgba(0, 245, 160, 0.20) 0%, rgba(0, 217, 245, 0.20) 100%)',
            text: 'Talent Transformation',
            iconBackground: '#2ECC71',
            description1:
                " Jobfactor is more than a platform; it's a transformative journey. We believe in forging lasting connections between talent and opportunities. Showcase your skills, celebrate your achievements and those of your coworkers, and embark on a path of continuous growth and success.",
            description2:
                " Discover a talent marketplace that goes beyond filling positions. Jobfactor is your gateway to forging meaningful connections with professionals whose values align with your organization's mission. Transform your talent acquisition strategy and cultivate a workforce that propels your company forward."
        },
        {
            // Advanced Algorithms for Rapid Connections
            id: 3,
            icon2: <AlgoCircleIcon />,
            icon: <AlgoIcon />,
            background2:
                'linear-gradient(90deg, rgba(114, 198, 239, 0.30) 0%, rgba(0, 78, 143, 0.30) 100%)',
            text: 'Advanced algorithm for rapid connection',
            iconBackground: '#3498DB',
            icon3: <AlgoIcon width="64px" height="64px" fill="#3498DB" />,
            description1:
                " Say goodbye to the tedious process of sifting through countless job listings. With our advanced algorithms, we ensure swift and precise connections between your skills and the right opportunities. Your time is valuable, and we're here to make every connection count.",
            description2:
                ' Efficiency is the backbone of successful hiring. Our advanced algorithms streamline the recruitment process, presenting you with prequalified professionals whose skills align seamlessly with your requirements. Experience the power of rapid connections without compromising on quality.'
        },
        {
            // Jobfactor Scores
            id: 4,
            icon2: <JobfactorScoreCircleIcon />,
            icon: <JobfactorScoreIcon />,
            icon3: (
                <JobfactorScoreIcon width="64px" height="64px" fill="#E74C3C" />
            ),
            background2:
                'linear-gradient(90deg, rgba(200, 78, 137, 0.30) 0%, rgba(241, 95, 121, 0.30) 100%)',
            text: 'Jobfactor scores',
            iconBackground: '#E74C3C',
            description1:
                ' If your entire professional history were to be represented numerically, what would that number be? Say hello to your personalized Jobfactor score, a powerful metric that transcends traditional qualifications! Let your unique score guide you to opportunities that align not just with your skills but with your professional ethos. Say goodbye to resume and cover letters and embrace your magic number for an amazing career opportunity.',
            description2:
                " Make data-driven hiring decisions with the Jobfactor score. It's not just about years of experience; it's about skills, credibility and results. Our comprehensive metric ensures surgical precision in connecting the right candidates with the right jobs, elevating your hiring proces."
        },
        {
            // Skill-based Hiring
            id: 5,
            icon2: <SkillBasedCircleIcon />,
            icon: <SkillsBasedIcon />,
            icon3: (
                <SkillsBasedIcon width="64px" height="64px" fill="#9B59B6" />
            ),
            background2:
                'linear-gradient(90deg, rgba(218, 34, 255, 0.30) 0%, rgba(151, 51, 238, 0.30) 100%)',
            text: 'Skill based hiring ',
            iconBackground: '#9B59B6',
            description1:
                ' Experience a paradigm shift in hiring dynamics. Jobfactor is committed to skill-based hiring, valuing your competencies over traditional metrics. Your true potential shines, and every opportunity is a meaningful step forward in your career.',
            description2:
                "Bid farewell to skill mismatches. Bring your requirements to our skill-based job marketplace, where  you find prequalified active  and passive  candidates who possesses the competencies needed for success in the role. It's not just about filling positions; it's about building a workforce that excel."
        },
        {
            // Social Media-Inspired Ecosystem
            id: 6,
            icon2: <SocialMediaCircleIcon />,
            icon: <SocialMediaIcon />,
            icon3: (
                <SocialMediaIcon width="64px" height="64px" fill="#F1C40F" />
            ),
            background2:
                'linear-gradient(90deg, rgba(240, 152, 25, 0.30) 0%, rgba(237, 222, 93, 0.30) 100%)',
            text: 'Social media-inspired ecosystem',
            iconBackground: '#F1C40F',
            description1:
                ' Step into an ecosystem where your professional journey is dynamic and vibrant. No static resumes or ATS; instead, showcase the best of your talent through peer reviews, skills ratings, and feedback. Join a culture of transparency and growth.',
            description2:
                " Experience   hiring   in   a   social   media-inspired   environment.   Jobfactor's ecosystem   allows   you   to   see   beyond   traditional   resumes,   gaining   insights   into   the   real achievements and skills of potential candidates. It's a transformative approach to building a team that thrives."
        },
        {
            // Upfront Screening
            id: 7,
            icon2: <UpfrontCircleIcon />,
            icon: <UpfrontIcon />,
            icon3: <UpfrontIcon width="64px" height="64px" fill="#008080" />,
            background2:
                'linear-gradient(90deg, rgba(86, 171, 47, 0.30) 0%, rgba(168, 224, 99, 0.30) 100%)',
            text: 'Upfront screening',
            iconBackground: '#008080',
            description1:
                ' Bid farewell to the uncertainty of the hiring process. Jobfactor incorporates upfront screening measures, ensuring that you are presented with opportunities that align withyour skills and aspirations from the star.',
            description2:
                " Make your hiring process more efficient with upfront screening. Jobfactor ensures that the candidates you review have already undergone initial screening, saving you time and enabling you to focus on the most promising talents. At Jobfactor, we're not just connecting people with jobs; we're connecting the right talent with the perfect job. Join us in shaping the future of successful and purpose-driven careers."
        }
    ];

    return (
        <Box
            sx={{
                backgroundColor: 'primaryBlue.main',
                // backgroundImage: `url(${BackgroundImage})`,
                background:
                    'linear-gradient(112deg, #FDE6FA -0.73%, #D6F0FF 105.17%)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundBlendMode: 'overlay',
                width: '100%',
                padding: { xs: '16px', sm: '20px', lg: '50px 60px' }
                // border:'2px solid red'
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Box
                    sx={{
                        width: '491px',
                        height: '100px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                        // border:'2px solid black'
                    }}
                >
                    <Footsteps />
                    <Typography
                        sx={{
                            color: '#23282B',
                            fontFamily: 'Cabinet Grotesk',
                            fontSize: { xs: '32px', sm: '60px' },
                            fontStyle: 'normal',
                            fontWeight: '800',
                            lineHeight: '100%',
                            letterSpacing: '-1.2px',
                            textTransform: 'capitalize'
                        }}
                    >
                        Our Approach
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignitems: 'center',
                    marginBottom: '50px'
                }}
            >
                <Box
                    sx={{
                        width: '956px',
                        // height: '72px',
                        // border:'2px solid black',
                        color: '#23282B',
                        textAlign: 'center',
                        fontFamily: 'Outfit',
                        fontSize: { xs: '16px', sm: '24px' },
                        fontStyle: 'normal',
                        fontWeight: '400',
                        lineHeight: '150%',
                        letterSpacing: '-0.48px'
                    }}
                >
                    Jobfactor uses a combination of tools to transform the
                    traditional hiring and professional networking process with
                    immense benefit to both employers and job seekers.
                </Box>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap',
                        width: '1320px',
                        justifyContent: 'center'
                        // height: '782px'
                        // border:'2px solid red'
                    }}
                >
                    <Box
                        display={{ xs: 'block', sm: 'none' }}
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                        sx={{
                            height: '250px'
                        }}
                    >
                        <img
                            src={image1}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '20px'
                            }}
                            alt=""
                        />
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(0, 1).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(1, 2).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(2, 3).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    <Box
                        display={{ xs: 'none', sm: 'block' }}
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                        sx={{
                            height: '250px'
                        }}
                    >
                        <img
                            src={image1}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '20px'
                            }}
                            alt=""
                        />
                    </Box>
                    <Box
                        display={{ xs: 'none', sm: 'block', md: 'none' }}
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                        sx={{
                            height: '250px'
                        }}
                    >
                        <img
                            src={image2}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '20px'
                            }}
                            alt=""
                        />
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(3, 4).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    <Box
                        display={{ xs: 'none', md: 'block' }}
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                        sx={{
                            height: '250px'
                        }}
                    >
                        <img
                            src={image2}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '20px'
                            }}
                            alt=""
                        />
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(4, 5).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    <Box
                        display={{ xs: 'none', sm: 'block', md: 'none' }}
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                        sx={{
                            height: '250px'
                        }}
                    >
                        <img
                            src={image1}
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '20px'
                            }}
                            alt=""
                        />
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(5, 6).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    <Box
                        width={{
                            xs: '100%',
                            sm: `${100 / 2.1}%`,
                            md: `${100 / 3.1}%`
                        }}
                    >
                        {OurApproachCards.slice(6, 7).map(
                            ({
                                icon2,
                                icon,
                                background2,
                                text,
                                iconBackground,
                                description1,
                                description2,
                                id,
                                icon3
                            }) => (
                                <OurApproachCard
                                    id={id}
                                    icon2={icon2}
                                    icon3={icon3}
                                    icon={icon}
                                    background2={background2}
                                    text={text}
                                    iconBackground={iconBackground}
                                    description1={description1}
                                    description2={description2}
                                />
                            )
                        )}
                    </Box>
                    {/* <TalentCard img={Talent} text="Talent Transformation" iconBackground="#2ECC71"/>
                    <AlgoCard  img={algovec} text="Advanced algorithm for rapid connection" iconBackground="#3498DB"/>
                    <SimpleCard  img={Rope} />
                    <JobfactorScoreCard img={jobfactorescore}  text="Jobfactor scores "   iconBackground="#E74C3C"/>
                    <SimpleCard  img={chips} />
                    <SkillsBasedCard  img={skillsbased} text="Skill based hiring " iconBackground="#9B59B6"/>
                    <UpfrontCard img={upfront} text="Upfront screening" iconBackground="#008080"/>
                    <SocialMediaCard  img={socialmedia} text="Social media-inspired ecosystem" iconBackground="#F1C40F"/> */}
                </Box>
            </Box>
        </Box>
    );
};

export default OurApproach;
